module.exports = __webpack_public_path__ + "images/company_profile/icon01-2ef0626284c60187d967f7ffcb72e0f4.png";